module.exports = __webpack_public_path__ + "static/media/forbes.com_sites_insertcoin_2016_07_09_ten-things-i-wish-i-knew-when-i-started-pokemon-go__plot.af32fe75.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/forbes.com_sites_insertcoin_2016_07_09_ten-things-i-wish-i-knew-when-i-started-pokemon-go__plot.png
// module id = 393
// module chunks = 0